import { useContext } from "react";
import { AuthContext } from "../../store/auth-context";
import Tour from "./Tour";
//? styles
import styles from "./Tours.module.css";

const Tours = () => {
  const toursCtx = useContext(AuthContext);

  return (
    <>
      {toursCtx.tours.length > 0 &&
        !toursCtx.error.hasError && (
          <section
            className={styles["tours-container"]}
          >
            <h1 className={styles["our-tours"]}>
              Our Tours
            </h1>
            <span id={styles["line"]}></span>
            {toursCtx.tours.map((tour) => {
              return (
                <Tour key={tour.id} {...tour} />
              );
            })}
          </section>
        )}
      {toursCtx.tours.length === 0 &&
        !toursCtx.error.hasError && (
          <section
            className={styles["tours-container"]}
          >
            <h1 className={styles["our-tours"]}>
              No Tours Left
            </h1>
            <button
              className={styles["button"]}
              type="button"
              onClick={toursCtx.onRefreshTours}
            >
              Refresh
            </button>
          </section>
        )}
    </>
  );
};

export default Tours;
